import "./NoData.css";
import { useEffect, useState } from "react";
import { translate } from "../../localization/translateService";

// Generic empty-state subtitle. Add this key to the localization dictionary (common_ns) for all
// languages; until then it gracefully falls back to the English text below.
const SUBTITLE_KEY = "EMPTY_STATE.SUBTITLE";
const SUBTITLE_FALLBACK =
  "Looks like this space is empty for now. Once there's something to show, you'll find it here.";

export default function NoData({ message, subtitle }) {
  const [sub, setSub] = useState(subtitle || SUBTITLE_FALLBACK);

  useEffect(() => {
    if (subtitle) {
      setSub(subtitle);
      return;
    }
    let alive = true;
    translate(SUBTITLE_KEY, true, SUBTITLE_FALLBACK).then((t) => {
      if (alive && t) setSub(t);
    });
    return () => {
      alive = false;
    };
  }, [subtitle]);

  return (
    <div className="no-data-container">
      <div className="no-data-illus">
        <div className="no-data-illus__inner">
          <svg className="no-data-illus__search" viewBox="0 0 77.0269 77.0269" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M45.7347 45.7347C49.4791 41.9904 51.3513 37.4437 51.3513 32.0946C51.3513 26.7455 49.4791 22.1988 45.7347 18.4544C41.9904 14.71 37.4437 12.8379 32.0946 12.8379C26.7455 12.8379 22.1988 14.71 18.4544 18.4544C14.71 22.1988 12.8379 26.7455 12.8379 32.0946C12.8379 37.4437 14.71 41.9904 18.4544 45.7347C22.1988 49.4791 26.7455 51.3513 32.0946 51.3513C37.4437 51.3513 41.9904 49.4791 45.7347 45.7347ZM32.0946 57.7702C24.9268 57.7702 18.8556 55.2829 13.8809 50.3082C8.90628 45.3336 6.41895 39.2624 6.41895 32.0946C6.41895 24.9268 8.90628 18.8556 13.8809 13.8809C18.8556 8.90628 24.9268 6.41895 32.0946 6.41895C39.2624 6.41895 45.3336 8.90628 50.3082 13.8809C55.2829 18.8556 57.7702 24.9268 57.7702 32.0946C57.7702 35.0901 57.3021 37.9117 56.3661 40.5595C55.43 43.2073 54.1061 45.6278 52.3944 47.8209L68.3614 63.7879C69.0033 64.4298 69.3242 65.1921 69.3242 66.0747C69.3242 66.9573 69.0033 67.7195 68.3614 68.3614C67.7195 69.0033 66.9572 69.3242 66.0747 69.3242C65.1921 69.3242 64.4298 69.0033 63.7879 68.3614L47.8209 52.3944C45.6278 54.1061 43.2073 55.43 40.5595 56.3661C37.9117 57.3021 35.0901 57.7702 32.0946 57.7702Z" fill="#A5ADB9" />
          </svg>
          <svg className="no-data-illus__box" viewBox="0 0 236.361 136.564" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M17.5082 56.0262H218.852V132.564C218.852 134.773 217.062 136.564 214.852 136.564H21.5082C19.2991 136.564 17.5082 134.773 17.5082 132.564V56.0262Z" fill="#C8CFD7" />
            <rect x="17.5082" y="56.0262" width="201.344" height="7.87869" fill="#A5ADB9" />
            <path d="M17.5082 0H218.852L236.361 56.0262H0L17.5082 0Z" fill="#E2E8F0" />
            <rect x="176.833" y="86.6656" width="28.8885" height="39.3934" rx="4" fill="#A5ADB9" />
          </svg>
        </div>
      </div>
      {message ? <div className="no-data-message-title">{message}</div> : null}
      {sub ? <div className="no-data-message-sub">{sub}</div> : null}
    </div>
  );
}
